import React from 'react'
import HomeHero from './HomeHero'
import './Home.css'
import HomeServices from './HomeServices'
import { Stats } from './Stats'
import WhyChoose from './WhyChoose'
import HomeCaseStudy from './HomeCaseStudy'
import TechStack from './TechStack'
import Industries from './Industries'
import Testimonial from './Testimonial'
import BookaCall from './BookaCall'
import FounderMessage from './FounderMessage'


const Home = () => {
  return (
    <>
    <HomeHero/>
    <Stats/>
    <HomeServices/>
    <WhyChoose/>
    <FounderMessage/>
    <HomeCaseStudy/>
<TechStack/>
<Industries/>
<Testimonial/>
<BookaCall/>
    </>
  )
}

export default Home